import React from 'react';
import { Button, Result } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleClearStorage = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '50px', textAlign: 'center' }}>
          <Result
            status="error"
            title="页面出现错误"
            subTitle="抱歉，页面加载时出现了一些问题。您可以尝试以下操作："
            extra={[
              <Button type="primary" key="reload" onClick={this.handleReload}>
                刷新页面
              </Button>,
              <Button key="clear" onClick={this.handleClearStorage}>
                清除缓存重新登录
              </Button>,
            ]}
          >
            <div style={{ textAlign: 'left', background: '#f5f5f5', padding: '20px', marginTop: '20px', borderRadius: '4px' }}>
              <h4>错误详情：</h4>
              <p style={{ color: 'red' }}>{this.state.error && this.state.error.toString()}</p>
              {this.state.errorInfo && (
                <details style={{ marginTop: '10px' }}>
                  <summary>查看详细信息</summary>
                  <pre style={{ marginTop: '10px', fontSize: '12px', overflow: 'auto' }}>
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
